// extracted by mini-css-extract-plugin
export default {"appCard":"AppCard_appCard__mjFNw","appCardInner":"AppCard_appCardInner__Omii+","appCardText":"AppCard_appCardText__7wJ6P"};